// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDZU-tZCcGPOvIamqKicR72tqpCB0SQQdI",
  authDomain: "lexgo-90df3.firebaseapp.com",
  projectId: "lexgo-90df3",
  storageBucket: "lexgo-90df3.firebasestorage.app",
  messagingSenderId: "579639198305",
  appId: "1:579639198305:web:261e9e3c06322e5ae3a020",
  measurementId: "G-T8BGK1R05H",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
